import React from "react";
import { Typography, Button, Card, Row, Col, Input, Checkbox } from "antd";
import dayjs from 'dayjs';
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant';

import { convertDateToUserTimezone } from '../Components/Utility';

const FieldDetails = ({ field, onBack }) => {
  const { Title } = Typography;

  // Define the exclusions for each type
  const typeBasedExclusions = {
    string: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    currency: ["lookup_config", "rollUp_config", "picklist_values", "relationship_name"],
    decimal: ["lookup_config", "rollUp_config", "picklist_values", "relationship_name"],
    integer: ["lookup_config", "rollUp_config", "picklist_values", "relationship_name"],
    picklist: ["lookup_config", "rollUp_config", "decimal_places_before", "decimal_places_after", "relationship_name"],
    multiselect: ["lookup_config", "rollUp_config", "decimal_places_before", "decimal_places_after", "relationship_name"],
    email: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    boolean: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    address: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    date: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    datetime: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    percentage: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    phone: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    url: ["lookup_config", "rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    rollup: ["lookup_config", "picklist_values", "decimal_places_before", "decimal_places_after"],
    lookup: ["rollUp_config", "picklist_values", "decimal_places_before", "decimal_places_after"],
    richtext: ["lookup_config", "picklist_values", "decimal_places_before", "decimal_places_after", "relationship_name"],
    textarea: ["lookup_config", "picklist_values", "decimal_places_before", "decimal_places_after", , "relationship_name"],
  };

  // Function to determine exclusions based on type
  const getExclusionsForType = (type) => {
    return typeBasedExclusions[type] || [];
  };

  // Function to format date fields
  const formatDate = (value) => {
    const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
    return typeof value === 'string' && isoDatePattern.test(value)
      ? convertDateToUserTimezone(value, DateTimeFormat)
      : value;
  };

  // Recursive function to render JSON data in a nested two-column format
  const renderJsonFields = (json) => {
    if (!json || typeof json !== "object") return null;
    return (
      <>
        <Row gutter={[16, 24]} style={{ marginTop: '15px' }}>
          {Object?.entries(json).map(([key, value]) => (
            <Col span={12} key={key}>
              <div style={{ marginBottom: "4px" }}>{key.replace(/_/g, " ")}</div>
              <div>
                {typeof value === "object" ? (
                  Array.isArray(value) ? (
                    <Input
                      disabled
                      value={value.join(", ")}
                      style={{
                        padding: 0,
                        fontWeight: 500,
                        color: "black",
                        borderBottom: "1px solid #ddd",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        backgroundColor: "transparent",
                        borderRadius: 0,
                      }}
                    />
                  ) : (
                    renderJsonFields(value)
                  )
                ) : typeof value === "boolean" ? (
                  <div style={{ borderBottom: "1px solid #ddd" }}>
                    <Checkbox checked={value} disabled />
                  </div>
                ) : (
                  <Input
                    disabled
                    value={formatDate(value)}
                    style={{
                      padding: 0,
                      fontWeight: 500,
                      color: "black",
                      // Keep these border overrides
                      borderBottom: "1px solid #ddd",
                      borderTop: "none",
                      borderLeft: "none",
                      borderRight: "none",
                      backgroundColor: "transparent",
                      borderRadius: 0,
                    }}
                  />
                )}
              </div>
            </Col>
          ))}
        </Row>
      </>
    );
  };

  // Get exclusions based on field type
  const typeExclusions = getExclusionsForType(field.type);

  // Filter out excluded keys and any fields with null values
  const filteredFields = Object.entries(field).filter(
    ([key, value]) =>
      !typeExclusions.includes(key) && value !== null
  );

  return (
    <Card style={{ height: '100vh', overflow: 'auto' }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={3}>Field Detail</Title>
        </Col>
        <Col>
          <Button type="default" onClick={onBack}>
            Back
          </Button>
        </Col>
      </Row>

      {/* Dynamic Row Layout */}
      <Row gutter={[16, 24]}>
        {filteredFields.map(([key, value]) => (
          <Col span={12} key={key}>
            <div style={{ marginBottom: "4px" }}>
              {key.replace(/_/g, " ")}
            </div>
            <div>
              {typeof value === "object" ? (
                renderJsonFields(value)
              ) : typeof value === "boolean" ? (
                <div style={{ borderBottom: "1px solid #ddd" }}>
                  <Checkbox checked={value} disabled />
                </div>
              ) : (
                <Input
                  disabled
                  value={formatDate(value)}
                  style={{
                    padding: 0,
                    fontWeight: 500,
                    color: "black",
                    // Keep these border overrides
                    borderBottom: "1px solid #ddd",
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    backgroundColor: "transparent",
                    backgroundColor: "transparent",
                    borderRadius: 0
                  }}
                />
              )}
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default FieldDetails;